<template>
  <footer>
    <button class="jokeRefresh" type="button" v-on:click="newJoke">
      <i class="material-icons spin-hover-item">refresh</i>
    </button>
    <joke :question="jokeQuestion" :answer="jokeAnswer" />
  </footer>
</template>

<script>

import joke from '@/components/widgets/joke.vue'
import * as jacktearleapi from '@/api/api.jacktearle.dev.js'

export default {
  name: 'footer',
  components: {
    joke
  },
  data () {
    return {
      jokeQuestion: '404 Joke not found.',
      jokeAnswer: '',
      jokeId: undefined,
      errors: []
    }
  },
  created () {
    this.newJoke()
  },
  methods: {
    newJoke: function (event) {
      jacktearleapi.GetRandomJoke(this.jokeId)
        .then(response => {
          console.log(response.data)
          this.jokeQuestion = response.data.question
          this.jokeAnswer = response.data.answer
          this.jokeId = response.data.id
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  background-color: #42b983;
  padding: 20px;
  color: #000;
  font-size: 20px;
  text-align: center;
}

.jokeRefresh {
  position: absolute;
  right: 0;
  background: none;
  border: none;
}
</style>
